module.exports = __webpack_public_path__ + "static/media/shopping-cart.c1553e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/shopping-cart.png
// module id = 91
// module chunks = 0